export default {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer"

      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/
    },
    {
      name: "Users",
      url: "/users",
      icon: "fa fa-user",
      meta: "admin"
      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/
    },
    {
      name: "User Groups",
      url: "/groups",
      icon: "fa fa-users",
      meta: "admin"
      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/
    },

    {
      name: "Dealers",
      url: "/dealers",
      icon: " fa fa-car"
      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/
    },
    {
      name: "Dealer Groups",
      url: "/dealergroups",
      icon: " fa fa-group-arrows-rotate",
      meta: "admin"
      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/
    },
    {
      name: "Campaigns",
      url: "/campaigns",
      icon: " fa fa-envelopes-bulk"
      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/
    }
    // {
    //   name: "Reports",
    //   url: "/reports",
    //   icon: " fa fa-solid fa-chart-column"
    //   /*badge: {
    //     variant: 'primary',
    //     text: 'NEW'
    //   }*/
    // }
    // ,
    // {
    //   name: "Email Templates",
    //   url: "/links",
    //   icon: " fa fa-code"
    //   /*badge: {
    //     variant: 'primary',
    //     text: 'NEW'
    //   }*/
    // }
  ]
};
